export default {
    name: 'sprints Management',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAllSprints: async (context) => {
            return await axios.get(`${synergy4}sprints/all`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        GetSprintById: async (context,id) => {
            return await axios.get(`${synergy4}sprints/GetSprintById?sprintId=${id}`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        getTasksDevTasks: async (context) => {
            return await axios.get(`${synergy4}tasks/DevTasks`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        getAllProjects: async (context) => {
            return await axios.get(`${synergy4}api/devprojects/getallprojects`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        removeTag: async (context,payload) => {
            return await axios.delete(`${synergy4}ticket-tags/${payload.ticketNumber}/${payload.tagId}`)
            .catch((err) => errorHandler.tomcatError(err))
        },
        addTicketNumber: async (context,payload) => {
            const url = `${synergy4}devtasks-association/create`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        editDevTask: async (context,payload) => {
            const url = `${synergy4}tasks/updatetask`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        reassigningDevTask: async (context,payload) => {
            const url = `${synergy4}tasks/reassign`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        reassignTaskUser: async (context, payload) => {
            const url = `${synergy4}tasks/reassign-user`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        createSprint: async (context,payload) => {
            const url = `${synergy4}sprints/create`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        updateStatus: async (context,payload) => {
            const url = `${synergy4}sprints/update-status`;
            const method = 'put';
            return await context.dispatch('sendRequest',{url,payload,method})
        },
        getTagTypes: async (context) => {
            return await axios.get(`${synergy4}types`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        createTageType: async (context,payload) => {
            const url = `${synergy4}types`;
            return await context.dispatch('sendRequest',{url,payload})
        },
    }
}
